import { render, staticRenderFns } from "./TopListCoupons.vue?vue&type=template&id=0b56c869&"
import script from "./TopListCoupons.vue?vue&type=script&lang=ts&"
export * from "./TopListCoupons.vue?vue&type=script&lang=ts&"
import style0 from "./TopListCoupons.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports